export const contentConstants = {
    GET_SUCCESS: 'CONTENT_GET_SUCCESS',
    GET_ERROR: 'CONTENT_GET_ERROR',
    GET_REQUEST: 'CONTENT_GET_REQUEST',

    PUT_SUCCESS: 'CONTENT_PUT_SUCCESS',
    PUT_ERROR: 'CONTENT_PUT_ERROR',
    PUT_REQUEST: 'CONTENT_PUT_REQUEST'
  }
  